import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mirror"];

  connect() {
    this.observeSource();
  }

  disconnect() {
    this.disconnectObserver();
  }

  observeSource() {
    // Use querySelector to find the source element dynamically
    this.source = document.querySelector('[data-sync-frame-target="source"]');
    this.mirror = this.mirrorTarget;

    if (!this.source || !this.mirror) {
      console.warn("Source or mirror not found.");
      return;
    }

    // Immediately copy content once
    this.mirror.innerHTML = this.source.innerHTML;

    // Disconnect old observer if any
    this.disconnectObserver();

    // Create and attach observer
    this.observer = new MutationObserver(() => {
      this.mirror.innerHTML = this.source.innerHTML;
    });

    this.observer.observe(this.source, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
